// extracted by mini-css-extract-plugin
export default {"wrapper":"cW-z","availablePromoMessagesLabel":"dW-z","promoMessageList":"eW-z","promoMessage":"fW-z","appliedPromoMessage":"gW-z","promoMessageAmount":"hW-z"};